import httpManager from "@/app/shared/utils/httpManager";
/**
 * Obtener descarga realizas por el usuario
 * @return {Promise<Object>} descarga.
 */
export async function fetchStrategy(strategyId: number) {
  const response = await httpManager.get(`strategies/${strategyId}/`);
  return response.data;
}
